import React from 'react';
import { useApp } from '../../context/AppContext';
import Header           from './Header';
import WorldBar         from './WorldBar';
import NavBar           from './NavBar';
import IdeaLab          from '../../pages/business/IdeaLab';
import ContentStudio    from '../../pages/business/ContentStudio';
import Calendar         from '../../pages/business/Calendar';
import ConsumerIdeas    from '../../pages/consumer/ConsumerIdeas';
import ConsumerCreate   from '../../pages/consumer/ConsumerCreate';
import ConsumerCalendar from '../../pages/consumer/ConsumerCalendar';
import BlogPosts        from '../../pages/consumer/BlogPosts';
import Settings         from '../../pages/settings/Settings';

export default function Shell() {
  const { activeWorld, bizTab, conTab, setConTab, dataLoading, dataError } = useApp();

  function navigateConCreate() {
    setConTab('con-create');
  }

  if (dataLoading) {
    return (
      <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', background:'var(--fog)' }}>
        <div style={{ textAlign:'center' }}>
          <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:24, fontWeight:700, color:'var(--caramel)', marginBottom:8 }}>Tayst</div>
          <div style={{ fontSize:12, color:'#9ca3af' }}>Loading your studio <span className="dots"><i/><i/><i/></span></div>
        </div>
      </div>
    );
  }

  if (dataError) {
    return (
      <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', background:'var(--fog)' }}>
        <div style={{ textAlign:'center', maxWidth:360 }}>
          <div style={{ fontSize:28, marginBottom:8 }}>⚠️</div>
          <div style={{ fontWeight:700, marginBottom:6 }}>Could not load data</div>
          <div style={{ fontSize:12, color:'#9ca3af', marginBottom:16 }}>{dataError}</div>
          <button className="btn btn-primary" onClick={() => window.location.reload()}>Retry</button>
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      <Header />
      <WorldBar />
      <NavBar />

      <div className="workspace">

        {/* ── Business World ── */}
        {activeWorld === 'biz' && (
          <>
            <div className={`view${bizTab === 'ideas'    ? ' active' : ''}`}><IdeaLab /></div>
            <div className={`view${bizTab === 'studio'   ? ' active' : ''}`}><ContentStudio /></div>
            <div className={`view${bizTab === 'calendar' ? ' active' : ''}`}><Calendar /></div>
          </>
        )}

        {/* ── Consumer World ── */}
        {activeWorld === 'con' && (
          <>
            <div className={`view${conTab === 'con-ideas'    ? ' active' : ''}`}>
              <ConsumerIdeas onNavigateCreate={navigateConCreate} />
            </div>
            <div className={`view${conTab === 'con-create'   ? ' active' : ''}`}>
              <ConsumerCreate />
            </div>
            <div className={`view${conTab === 'con-calendar' ? ' active' : ''}`}>
              <ConsumerCalendar onNavigateCreate={navigateConCreate} />
            </div>
            <div className={`view${conTab === 'con-blog'     ? ' active' : ''}`}>
              <BlogPosts onNavigateCreate={navigateConCreate} />
            </div>
          </>
        )}

        {/* ── Settings ── */}
        {activeWorld === 'set' && (
          <div className="view active" id="view-settings">
            <Settings />
          </div>
        )}
      </div>
    </div>
  );
}
